import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {toTopicPayload} from '../../lib/types/generic-payload'

export function TopicPage() {
  const {title = 'Artificial Intelligence'} = toTopicPayload(useRoutePayload<unknown>())

  return <h1>{title}</h1>
}

try{ TopicPage.displayName ||= 'TopicPage' } catch {}